"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>UserInputBar
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const index_js_namespaceObject = require("../../constants/index.js");
const VoiceControlButton_js_namespaceObject = require("../Realtime/VoiceControlButton/VoiceControlButton.js");
var VoiceControlButton_js_default = /*#__PURE__*/ __webpack_require__.n(VoiceControlButton_js_namespaceObject);
const useRealTimeContext_js_namespaceObject = require("../../hooks/useRealTimeContext.js");
const UserInputContainer = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Flex).withConfig({
    displayName: "UserInputBar__UserInputContainer"
})([
    "height:67px;margin:1px;border-radius:0 0 24px 24px;padding:0 8px;align-items:center;background-color:",
    ";justify-content:space-between;width:",
    ";"
], (props)=>(0, external_pcln_design_system_namespaceObject.getPaletteColor)('background.lightest')(props), (props)=>props?.styles?.inputGradientFocus ? '100%' : '');
function UserInputBar_UserInputBar(props) {
    const { limiterCheck = ()=>{}, styles } = props;
    const [textInput, setTextInput] = (0, external_react_namespaceObject.useState)('');
    const inputRef = (0, external_react_namespaceObject.useRef)(null);
    const { isRealtime } = (0, useRealTimeContext_js_namespaceObject.useRealTimeContext)();
    const { MAXLENGTH } = index_js_namespaceObject.messageInputConfig;
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (inputRef.current) inputRef.current.focus();
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        limiterCheck(textInput.length);
    }, [
        textInput,
        props.isLoading
    ]);
    function handleTextChange(e) {
        setTextInput(e.target.value);
    }
    function handleTextSubmit() {
        if (props.isLoading || props.isDisablingInput || !textInput) return;
        setTextInput('');
        if (props.onTextSubmit) props.onTextSubmit(textInput);
    }
    function onKeyUpHandler(event) {
        if ('Enter' === event.key) handleTextSubmit();
    }
    const [isFocused, setIsInputFocused] = (0, external_react_namespaceObject.useState)(false);
    function handleInputFocus() {
        setIsInputFocused(true);
    }
    function handleInputBlur() {
        setIsInputFocused(false);
    }
    const inputColor = textInput.length >= MAXLENGTH ? external_pcln_design_system_namespaceObject.theme.colors.red : external_pcln_design_system_namespaceObject.theme.colors.blue;
    const inputStyle = styles?.inputGradientFocus ? isFocused ? {
        ...styles?.inputGradientFocus
    } : {
        ...styles?.inputGradientNoFocus
    } : {
        borderStyle: 'none',
        borderRadius: '24px',
        boxShadow: `0 0 0 2px ${inputColor}`
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(UserInputContainer, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Card, {
                mr: 2,
                width: '100%',
                borderRadius: 24,
                boxShadowSize: "sm",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Input, {
                    onFocus: handleInputFocus,
                    onBlur: handleInputBlur,
                    style: inputStyle,
                    maxLength: MAXLENGTH,
                    disabled: props.isDisablingInput,
                    id: "chatInput",
                    "data-testid": "chatInput",
                    autoComplete: "off",
                    onChange: handleTextChange,
                    value: textInput,
                    placeholder: "Ask Penny a question",
                    onKeyUp: onKeyUpHandler,
                    mr: 2,
                    ref: inputRef
                })
            }),
            textInput && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                onClick: handleTextSubmit,
                "data-testid": "chatSubmitButton",
                mr: 2,
                height: "49px",
                children: "Submit"
            }),
            isRealtime ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VoiceControlButton_js_default(), {}) : null
        ]
    });
}
const UserInputBar = UserInputBar_UserInputBar;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
